var map = {
	"./amplify-amazon-button_5.entry.js": [
		2192,
		9
	],
	"./amplify-auth-fields_9.entry.js": [
		2193,
		20
	],
	"./amplify-authenticator.entry.js": [
		2194,
		5
	],
	"./amplify-button_3.entry.js": [
		2195,
		10
	],
	"./amplify-chatbot.entry.js": [
		2196,
		8
	],
	"./amplify-checkbox.entry.js": [
		2197,
		27
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		2198,
		6
	],
	"./amplify-container.entry.js": [
		2199,
		28
	],
	"./amplify-federated-buttons_2.entry.js": [
		2200,
		11
	],
	"./amplify-federated-sign-in.entry.js": [
		2201,
		21
	],
	"./amplify-form-field_4.entry.js": [
		2202,
		29
	],
	"./amplify-greetings.entry.js": [
		2203,
		12
	],
	"./amplify-icon-button.entry.js": [
		2204,
		30
	],
	"./amplify-icon.entry.js": [
		2205,
		24
	],
	"./amplify-link.entry.js": [
		2206,
		31
	],
	"./amplify-nav_2.entry.js": [
		2207,
		13
	],
	"./amplify-photo-picker.entry.js": [
		2208,
		22
	],
	"./amplify-picker.entry.js": [
		2209,
		23
	],
	"./amplify-radio-button_2.entry.js": [
		2210,
		7
	],
	"./amplify-s3-album.entry.js": [
		2211,
		14
	],
	"./amplify-s3-image-picker.entry.js": [
		2212,
		15
	],
	"./amplify-s3-image.entry.js": [
		2213,
		19
	],
	"./amplify-s3-text-picker.entry.js": [
		2214,
		16
	],
	"./amplify-s3-text.entry.js": [
		2215,
		17
	],
	"./amplify-select-mfa-type.entry.js": [
		2216,
		18
	],
	"./amplify-sign-in-button.entry.js": [
		2217,
		25
	],
	"./amplify-toast.entry.js": [
		2218,
		32
	],
	"./amplify-tooltip.entry.js": [
		2219,
		33
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1483;
module.exports = webpackAsyncContext;